exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-657ae92f] .v-card__title {\n  padding: 16px 22px 10px !important;\n}\n[data-v-657ae92f] * {\n  font-family: \"Jost\", sans-serif !important;\n}", ""]);

// exports
